import axios from 'axios'
import { baseURL } from './config.js'
import qs from 'qs'

export default {
  getAdminModule(params) { //获取模块列表
    const url =  baseURL + '/tbModule/list';
    return axios.post(url, qs.stringify(params));
  },
  setAdminModule(params) { //新增编辑模块
    const url =  baseURL + '/tbModule/modify';
    return axios.post(url, qs.stringify(params));
  },
  delAdminModule(params) { //删除模块
    const url =  baseURL + '/tbModule/delete';
    return axios.post(url, qs.stringify(params));
  },

}


// WEBPACK FOOTER //
// ./src/api/models.js